function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaitingPicture2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-line-drawing--picture2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "250px",
    height: "180px",
    viewBox: "0 0 250 180",
    style: {
      overflow: "visible",
      enableBackground: "new 0 0 250 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Cloud",
    className: "svg-line-drawing__line",
    d: "M4.4,26.5c2-0.7,4.5-1.1,7.6-1c0.3-16,30.2-12.3,26.7,6.6c8.1-3.9,13.4-0.1,13.2,7.2c0,1.2-1.1,3.7-4.7,3.7c-3.1,0-32.6,0-42.8,0",
    style: {
      strokeDasharray: 119.42950439453125,
      strokeDashoffset: 119.42950439453125
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Horizon",
    className: "svg-line-drawing__line",
    x1: 5.3,
    y1: 116,
    x2: 246.1,
    y2: 116,
    style: {
      strokeDasharray: 240.8000030517578,
      strokeDashoffset: 240.8000030517578
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Outline",
    className: "svg-line-drawing__line",
    d: "M4,179c-1.7,0-3-1.4-3-3V4c0-1.7,1.3-3,3-3h242c1.6,0,3,1.3,3,3v172c0,1.6-1.4,3-3,3H4z",
    style: {
      strokeDasharray: 846.8409423828125,
      strokeDashoffset: 846.8409423828125
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "White_11",
    className: "svg-line-drawing__white",
    d: "M126.6,175.9c0-7.8-0.3-15.6-0.9-21.9c-3.2-34.8-24-61.3-46.4-59.2c-22.5,2.1-38.1,31.9-34.9,66.7c0.5,5.1,1.3,9.9,2.3,14.5",
    style: {
      strokeDasharray: 201.9699249267578,
      strokeDashoffset: 201.9699249267578
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Body_1",
    className: "svg-line-drawing__line",
    d: "M126.6,172.3c-0.1-6.6-0.3-12.9-0.8-18.3c-3.2-34.8-24-61.3-46.4-59.2c-22.5,2.1-38.1,31.9-34.9,66.7c0.5,5.1,1.3,9.9,2.3,14.5",
    style: {
      strokeDasharray: 198.36561584472656,
      strokeDashoffset: 198.36561584472656
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "White_10",
    className: "svg-line-drawing__white",
    d: "M106.8,175.9c-0.7-10.8-0.7-22.6,0.6-34.7c4.5-42.2,30.7-74,58.4-71s46.5,39.6,42,81.8c-0.7,6.8-2.2,15.3-3.8,23.9",
    style: {
      strokeDasharray: 261.1258239746094,
      strokeDashoffset: 261.1258239746094
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Body_2",
    className: "svg-line-drawing__line",
    d: "M106.8,175.9c-0.7-10.8-0.7-22.6,0.6-34.7c4.5-42.2,30.7-74,58.4-71s46.5,39.6,42,81.8c-0.7,6.8-2.2,15.3-3.8,23.9",
    style: {
      strokeDasharray: 261.1258239746094,
      strokeDashoffset: 261.1258239746094
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "White_9",
    className: "svg-line-drawing__white",
    d: "M43.5,127c-4.5,0-8.2,5.1-8.2,11.3s3.7,11.3,8.2,11.3s8.2-5.1,8.2-11.3S48,127,43.5,127z",
    style: {
      strokeDasharray: 61.59975814819336,
      strokeDashoffset: 61.59975814819336
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "White_8",
    className: "svg-line-drawing__white",
    d: "M215.2,110.3c-1.2-6.1-6.3-10.3-11.3-9.3c-2.5,0.5-4.5,2.1-5.8,4.6c-1.2,2.4-1.6,5.4-1,8.3c1.1,5.5,5.3,9.5,9.8,9.5c0.5,0,1,0,1.5-0.1C213.3,122.2,216.4,116.4,215.2,110.3z",
    style: {
      strokeDasharray: 64.81417846679688,
      strokeDashoffset: 64.81417846679688
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "White_7",
    className: "svg-line-drawing__white",
    d: "M65.6,54c-16.3,0-29.5,13.2-29.5,29.5s13.2,29.5,29.5,29.5c16.3,0,29.5-13.2,29.5-29.5S81.9,54,65.6,54z",
    style: {
      strokeDasharray: 185.3932647705078,
      strokeDashoffset: 185.3932647705078
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "White_6",
    className: "svg-line-drawing__white",
    d: "M169.4,17.9c-17.7,0-32.1,14.4-32.1,32.1S151.7,82,169.4,82c17.7,0,32.1-14.4,32.1-32.1S187.1,17.9,169.4,17.9z",
    style: {
      strokeDasharray: 201.53663635253906,
      strokeDashoffset: 201.53663635253906
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Hand_1",
    className: "svg-line-drawing__line",
    d: "M36.3,138.4c0,5.7,3.2,10.3,7.2,10.3s7.2-4.6,7.2-10.3c0-2.3-0.5-4.4-1.4-6.1c-1.3-2.6-3.4-4.2-5.8-4.2C39.5,128,36.3,132.7,36.3,138.4z",
    style: {
      strokeDasharray: 55.48905944824219,
      strokeDashoffset: 55.48905944824219
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Hand_2",
    className: "svg-line-drawing__line",
    d: "M198,113.7c1.1,5.6,5.7,9.4,10.1,8.5c4.5-0.9,7.2-6.2,6.1-11.8c-0.5-2.6-1.8-4.9-3.5-6.4c-1.9-1.7-4.3-2.6-6.6-2.1C199.6,102.8,196.9,108.1,198,113.7z",
    style: {
      strokeDasharray: 58.63873291015625,
      strokeDashoffset: 58.63873291015625
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Head_1",
    className: "svg-line-drawing__line",
    d: "M37.1,83.6c0,15.8,12.8,28.5,28.5,28.5s28.5-12.8,28.5-28.5c0-10.7-5.9-20-14.5-24.9c-4.1-2.3-8.9-3.7-14-3.7C49.8,55,37.1,67.8,37.1,83.6z",
    style: {
      strokeDasharray: 179.2313690185547,
      strokeDashoffset: 179.2313690185547
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Head_2",
    className: "svg-line-drawing__line",
    d: "M138.4,50c0,17.2,13.9,31.1,31.1,31.1c1.3,0,2.6-0.1,3.9-0.2c15.3-1.9,27.1-15,27.1-30.8c0-17.2-13.9-31.1-31.1-31.1S138.4,32.8,138.4,50z",
    style: {
      strokeDasharray: 195.21157836914062,
      strokeDashoffset: 195.21157836914062
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Mouth_2",
    className: "svg-line-drawing__line",
    d: "M54,95.1c0,0,7.7,9.2,20.9,3.5",
    style: {
      strokeDasharray: 22.653202056884766,
      strokeDashoffset: 22.653202056884766
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Mouth_1",
    className: "svg-line-drawing__line",
    d: "M163.8,66.6c0,0,10.6,5.7,20.7-4.4",
    style: {
      strokeDasharray: 22.61786651611328,
      strokeDashoffset: 22.61786651611328
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingPicture2);
export default __webpack_public_path__ + "static/media/WaitingPicture2.ab1657e1c31f2cb4f179b96155827796.svg";
export { ForwardRef as ReactComponent };